import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import { c as classNames } from '../../shared/bind-56cf2a3b.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "double-image": "web_ui__DoubleImage__double-image",
  "secondary": "web_ui__DoubleImage__secondary",
  "tight": "web_ui__DoubleImage__tight",
  "with-border": "web_ui__DoubleImage__with-border"
};

var Relationship = /*#__PURE__*/function (Relationship) {
  Relationship["Tight"] = "tight";
  return Relationship;
}(Relationship || {});
var SecondaryBorder = /*#__PURE__*/function (SecondaryBorder) {
  SecondaryBorder["Default"] = "default";
  return SecondaryBorder;
}(SecondaryBorder || {});
var cssClasses = classNames.bind(styles);
var DoubleImage = function DoubleImage(_ref) {
  var primary = _ref.primary,
    secondary = _ref.secondary,
    secondaryBorder = _ref.secondaryBorder,
    relationship = _ref.relationship,
    testId = _ref.testId;
  var doubleImageClass = cssClasses('double-image', relationship, _defineProperty({}, styles['with-border'], secondaryBorder === SecondaryBorder.Default));
  return /*#__PURE__*/jsxs("div", {
    className: doubleImageClass,
    "data-testid": testId,
    children: [primary, /*#__PURE__*/jsx("div", {
      className: styles.secondary,
      children: secondary
    })]
  });
};
DoubleImage.Relationship = Relationship;
DoubleImage.SecondaryBorder = SecondaryBorder;

export { DoubleImage as default };
//# sourceMappingURL=DoubleImage.js.map
